import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { Utils } from '../functions/utils'
import { ws } from '../functions/ws'
import { IState } from '../models/state'

export const KycMain = () => {

	const kyc = useSelector((state: IState) => state.kyc)

	React.useEffect(() => {
		ws.send({ type: 'Kyc.GetList' } as any)
	}, [])

	return (
		<div className='ordersMain'>
			<span className='pageTitle'>KYC</span>
			<span className='pageBoxTitle'>Pending KYC</span>
			<div>
				<table className='ordersTableMain'>
					<thead>
						<tr className='ordersTableHeaderRow'>
							<td className='ordersTableHeaderRowItem dateColumn'>Register Date</td>
							<td className='ordersTableHeaderRowItem idColumn'>User ID</td>
							<td className='ordersTableHeaderRowItem'>Email</td>
							<td className='ordersTableHeaderRowItem dateColumn'>Last seen</td>
							<td className='ordersTableHeaderRowItem'>Actions</td>
						</tr>
					</thead>
					<tbody>
						{kyc.map(m =>
							<tr className='ordersTableBodyRow' key={m.id}>
								<td className='ordersTableBodyRowItem'>{m.registerDate ? new Date(m.registerDate).toLocaleString('en-GB') : ''}</td>
								<td className='ordersTableBodyRowItem'>{Utils.pad(Utils.base32.encode(m.id), 6)}</td>
								<td className='ordersTableBodyRowItem'>{m.email}</td>
								<td className='ordersTableBodyRowItem'>{m.lastSeen ? new Date(m.lastSeen).toLocaleString('en-GB') : ''}</td>
								<td className='ordersTableBodyRowItem'><Link className='walletsTableButton' to={`/userKyc/${m.id}`}>View Details</Link></td>
							</tr>
						)}
					</tbody>
				</table>
			</div>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/components/kycMain.tsx